<template>
  <div v-if="active_chat">
    <button
      type="button"
      class="btn btn-success whatsapp"
      data-toggle="modal"
      data-target="#myModal"
    >
      escribinos
      <i class="fa fa-comment"></i>
    </button>

    <!-- Page Preloder -->
    <!-- <div id="preloder">
      <div class="loader"></div>
    </div> -->

    <div class="modal fade" id="myModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <!-- <div class="panel-heading">
                    <span class="glyphicon glyphicon-comment"></span> Chat
                    <div class="btn-group pull-right">
                      <button
                        type="button"
                        class="btn btn-default btn-xs dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <span class="glyphicon glyphicon-chevron-down"></span>
                      </button>
                      
                    </div> 
                  </div>-->
                  <div class="panel-body my-3 p-2" style="overflow-y: auto !important;" v-chat-scroll="{smooth: true, notSmoothOnInit: true}">
                    <ul class="chat mr-3">
                      <li
                        class="clearfix"
                        :class="[message.sender ? 'left' : 'right']"
                        v-for="(message, index) in messages"
                        :key="index"
                      >
                        <div class="chat-body clearfix">
                          <div class="header">
                            <strong class="primary-font">{{ message.name }}</strong>
                            <small class="pull-right text-muted">
                              <span class="glyphicon glyphicon-time"></span>
                              {{ message.created_at | moment("HH:mm") }}
                            </small>
                          </div>
                          <p>{{ message.message }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="panel-footer mb-3">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input type="text" class="form-control form-control-sm" v-model="name" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <textarea v-model="message" class="form-control form-control-sm" rows="3"></textarea>
                        </div>
                      </div>
                    </div>
                    <el-button
                      :disabled="message === ''"
                      type="warning"
                      :loading="loading"
                      size="mini"
                      @click="do_send_message"
                    >enviar</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, fire } from "./../lib/firebase";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      name: "Anonimo",
      message: "",
    };
  },
  computed: {
    ...mapState({
      messages: (state) => state.FrontChat.messages,
      chat: (state) => state.FrontChat.chat,
      loading: (state) => state.FrontChat.loading,
      active_chat: (state) => state.FrontChat.active_chat,
    }),
	},
	created(){
		this.get_active_chat()
	},
  methods: {
    ...mapActions({
			send_message: "FrontChat/send_message",
			get_active_chat: "FrontChat/get_active_chat"
    }),
    do_send_message() {
      this.send_message({
        sender: true,
        name: this.name,
        message: this.message,
      });

      this.message = "";
    },
  },
};
</script>

<style scoped>
.chat-body {
  background: #f7f7f7;
  padding: 5px 10px;
  border-radius: 5px;
  border: #eceaea 1px solid;
}

.chat li {
  border: none !important;
}

.panel-body {
    border: #eceaea 1px solid;
}
</style>